import { CheckoutTypes } from 'common/billing/constants/checkoutTypes'

export const getStripeCheckoutType = (isTrialAvailable: boolean, isCouponApplied: boolean) => {
  return isTrialAvailable && !isCouponApplied ? CheckoutTypes.TRIAL : CheckoutTypes.UPGRADE_TO_PRO
}
